// Message types for communication between dashboard and custom module iframes
var SET_GLOBAL_DATA = 'setGlobalData';
var VISIBILITY_CHANGE = 'visibilityChange';
var PANE_STATE_CHANGE = 'paneStateChange';

// Parent-to-Flutter (SlatePane protocol)
var INIT = 'init';
var NAVIGATE = 'navigate';
var UPDATE_USER = 'updateUser';
var UPDATE_STACKS = 'updateStacks';

var RESET = 'reset';

// Flutter-to-parent (SlatePane protocol)
var FLUTTER_READY = 'flutterReady';
var NAVIGATE_ACCEPTED = 'navigateAccepted';
var NAVIGATE_REJECTED = 'navigateRejected';
var CONTENT_LOADED = 'contentLoaded';
var CONTENT_ERROR = 'contentError';
var CONTENT_CHANGED = 'contentChanged';
var CONTENT_SAVED = 'contentSaved';
var RESET_ACCEPTED = 'resetAccepted';
var PRINT_PDF = 'printPdf';

module.exports = {
  SET_GLOBAL_DATA: SET_GLOBAL_DATA,
  VISIBILITY_CHANGE: VISIBILITY_CHANGE,
  PANE_STATE_CHANGE: PANE_STATE_CHANGE,
  INIT: INIT,
  NAVIGATE: NAVIGATE,
  UPDATE_USER: UPDATE_USER,
  UPDATE_STACKS: UPDATE_STACKS,
  RESET: RESET,
  FLUTTER_READY: FLUTTER_READY,
  NAVIGATE_ACCEPTED: NAVIGATE_ACCEPTED,
  NAVIGATE_REJECTED: NAVIGATE_REJECTED,
  CONTENT_LOADED: CONTENT_LOADED,
  CONTENT_ERROR: CONTENT_ERROR,
  CONTENT_CHANGED: CONTENT_CHANGED,
  CONTENT_SAVED: CONTENT_SAVED,
  RESET_ACCEPTED: RESET_ACCEPTED,
  PRINT_PDF: PRINT_PDF,
};
